import React, { Component } from 'react';
import { TextField, Box, FormControl, InputLabel, Select, FormHelperText, OutlinedInput, InputAdornment } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { green } from '@material-ui/core/colors';
            
class InputText extends Component{

    render(){
        const { 
            name,
            value,
            error,
            change,
            onChange,
            title,
            placeholder,
            disabled,
            required,
            label,
            helperText,
            min,
            max,
            step,
            type,
            rows,
            defaultValue,
            endAction,
            size
        } = this.props
        
        return(     
            <Box p={1} >       
                <TextField
                    // margin="normal"
                    name={name} 
                    min={min} 
                    max={max} 
                    // step={step} 
                    id={name} 
                    value={value} 
                    label={label || title || placeholder} 
                    placeholder={placeholder || title}
                    onChange={ onChange || change } 
                    error={!!error} 
                    helperText={error || helperText} 
                    type={type || "text"}
                    onWheel={(e) => e.target.blur()}
                    required={required}
                    disabled={disabled}
                    rows={rows || 1}
                    multiline={rows > 1}
                    style={{ width:"100%" }}
                    variant="outlined"
                    defaultValue={defaultValue}  
                    color="secondary"
                    InputProps={{ 
                        endAdornment: <InputAdornment position="end">{endAction}</InputAdornment>
                    }}
                    {...this.props}
                    size={size || "medium"}
                />
            </Box>
        )
    }           
}

export default InputText;

export class InputSelect extends Component{
              
    render(){
        const { 
            name,
            value,
            onChange,
            title,
            disabled,
            required,
            options,
            isMulti,
            placeholder,
            label,
            error,
            helperText
        } = this.props
        
        return(     
            <Box p={1} >  
                <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
                    <Autocomplete
                        value={(options && options.find(opt => opt.value === value)) || null}
                        placeholder={placeholder}
                        options={options}
                        getOptionLabel={(option) => option?.label || ""}
                        getOptionSelected={(option, val) => option && val && option.value === val.value}
                        getOptionDisabled={(option) => option?.disabled}
                        onChange={(e, option) => option && onChange(option, option.value)}
                        required={required}
                        disabled={disabled}
                        multiple={isMulti}
                        renderInput={(params) => <TextField 
                            variant="outlined" 
                            {...params} 
                            label={label || title} 
                            name={name} 
                            id={name} 
                            error={!!error} 
                            helperText={error || helperText} 
                            color="secondary"
                            />
                        }
                        disableClearable
                    />  
                    {/* <FormHelperText>{error || helperText}</FormHelperText> */}
                </FormControl>              
            </Box>
        )
    }           
}
export class InputSelectMagasin extends Component{
              
    render(){
        const { 
            name,
            value,
            onChange,
            inputValue,
            onInputChange,
            title,
            disabled,
            required,
            options,
            isMulti,
            placeholder,
            label,
            error,
            helperText,
            maxWidth
        } = this.props
        
        return(     
            <Box p={1} style={{width: (maxWidth && "100%")}}>  
                <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
                    <Autocomplete
                        value={value}
                        placeholder={placeholder}
                        options={options}
                        getOptionLabel={(option) => option?.label || ""}
                        getOptionSelected={(option) => {
                            if (!option || !value) return false;
                            return option.value === (value?.value ?? value);
                        }}
                        getOptionDisabled={(option) => option?.disabled}
                        inputValue={inputValue}
                        onInputChange={onInputChange ||function() {} }
                        onChange={(e, option) => option && onChange(option, option.value)}
                        required={required}
                        disabled={disabled}
                        multiple={isMulti}
                        renderInput={(params) => <TextField 
                            variant="outlined" 
                            {...params} 
                            label={label || title} 
                            name={name} 
                            id={name} 
                            error={!!error} 
                            helperText={error || helperText} 
                            color="secondary"
                            style= {{
                                whiteSpace: 'pre-wrap', // permet le retour à la ligne
                                width: '100%', // occupe toute la largeur disponible
                            }}
                            multiline={true} // affiche plusieurs lignes
                            />
                        }
                        renderOption={(option) => (
                            <Box p={1}
                              style={{
                                backgroundColor: (option.dispo && green[100]),
                                width: '100%',
                                borderRadius: "15px",
                              }}
                            >
                              {option.label}
                            </Box>
                          )}
                        disableClearable
                        disableCloseOnSelect={isMulti}
                    />  
                    {/* <FormHelperText>{error || helperText}</FormHelperText> */}
                </FormControl>              
            </Box>
        )
    }           
}


export class InputSelectNative extends Component{
                    
    render(){
        const { 
            name,
            value,
            onChange,
            change,
            title,
            disabled,
            required,
            options,
            isMulti,
            placeholder,
            label,
            error,
            helperText,
            labelWidth, 
            noEmptyOpt,
        } = this.props
        
        return(     
            <Box p={1} >      
                <FormControl variant="outlined" style={{width: "100%"}}>
                    <InputLabel htmlFor={name} color="secondary">{label || title}</InputLabel>
                    <Select
                        native
                        onChange={onChange || change}
                        value={value}
                        required={required}
                        disabled={disabled}
                        error={!!error} 
                        color="secondary"
                        input={<OutlinedInput className={!!error && "Mui-error"} labelWidth={labelWidth || 120} name={name} id={name} color="secondary" />}
                    >
                        {!noEmptyOpt && <option value="" /> }
                        {options}
                    </Select>
                    <FormHelperText className={!!error && "Mui-error"}>{error || helperText}</FormHelperText>
                </FormControl>
            </Box>
        )
    }           
}

export class TextArea extends Component{

    render(){
        const { 
            name,
            value,
            error,
            change,
            onChange,
            title,
            placeholder,
            disabled,
            label,
            required,
            rows  } = this.props
        
        return(
            <Box p={1} >
                <TextField
                    // margin="normal"
                    type="text"
                    name={name} 
                    id={name} 
                    value={value} 
                    label={label || title || placeholder} 
                    placeholder={placeholder || title}
                    onChange={ onChange || change } 
                    error={!!error} 
                    helperText={error} 
                    required={required}
                    disabled={disabled}
                    rows={rows || 3}
                    multiline
                    style={{ width:"100%" }}
                    variant="outlined"  
                    color="secondary"
                />
            </Box>
        )
    }           
}

export class InputSelectMulti extends Component{
                    
    render(){
        const { 
            name,
            value,
            onChange,
            title,
            disabled,
            required,
            options,
            isMulti,
            placeholder,
            label,
            error,
            helperText
        } = this.props
        
        return(     
            <Box p={1} >    
                <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
                  <Autocomplete
                      placeholder={placeholder}
                      options={options}
                      getOptionLabel={(option) => option?.label || ""}
                      getOptionSelected={(option) => option && value !== undefined && option.value === value}
                      getOptionDisabled={(option) => option?.disabled}
                      onChange={(e, option) => option && onChange(option, option.value)}
                      required={required}
                      disabled={disabled}
                      multiple={isMulti}
                      disableCloseOnSelect={isMulti}
                      renderInput={(params) => <TextField variant="outlined" {...params} label={label || title} name={name} id={name} color="secondary" />}
                  />    
                  <FormHelperText>{error || helperText}</FormHelperText>
                </FormControl>          
            </Box>
        )
    }           
  }